import { render } from "./CreateNews.vue?vue&type=template&id=6c3c04f9&scoped=true"
import script from "./CreateNews.vue?vue&type=script&lang=js"
export * from "./CreateNews.vue?vue&type=script&lang=js"

import "./CreateNews.vue?vue&type=style&index=0&id=6c3c04f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3c04f9"]])

export default __exports__